import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

const noEntry = 'No entry';
const noEntryDe = 'Keine Angabe';

// todo
const resources = {
    'en-US': {
        translation: {
            AccountSettings: {
                TITLE: 'Account Settings'
            },
            AccountTypeSelection: {
                TITLE: 'Registration',
                REGISTER_TEAM: 'Register team',
                REGISTER_ATHLETE: 'Register as athlete'
            },
            Button: {
                ADD: 'Add',
                CANCEL: 'Cancel',
                CONFIRM: 'Confirm',
                DELETE: 'Delete',
                EDIT: 'Edit',
                EXTEND: 'Extend',
                FILTER: 'Filter',
                FILTER_RESET: 'Reset filter',
                RESET: 'Reset',
                SELECT_ALL: 'Select all',
                SAVE: 'Save',
                SAVE_AND_CONTINUE: 'Save and continue',
                SAVE_CHANGES: 'Save changes',
                CONTINUE: 'Continue',
                GO_BACK_TO_OVERVIEW: 'Go back to overview',
                OK: 'Ok',
                CLOSE: 'Close',
                OPEN: 'Open',
                REMOVE: 'Remove',
                REGISTER: 'Register',
                SEND: 'Send',
                YES: 'Yes',
                NO: 'No',
                IMPORT: 'Import',
                IMPORT_TRAINING: 'Import training',
                NEXT: 'Next',
                OVERVIEW: 'Overview',
                RUNS: 'Runs',
                ATHLETE: 'Athlete',
                DOWNLOAD: 'Download',
                RUN_ADD: 'Add run',
                SHARE: 'Share',
                COLUMNS: 'Columns',
                ADD_ACCOUNT: 'Add account',
                ADMIN_MENU: 'Admin menu',
                VERIFY_ACCOUNT: 'Verify account'
            },
            Club: {
                ADD: 'New Club',
                EDIT: 'Edit Club',
                NAME: 'Name',
                CLUB_OVERVIEW: 'All Clubs',
                SERIAL_NUMBER: 'Serial number',
                SERIAL_NUMBER_ALP: 'Serial number of  the Alpenhunde-system',
                PAYMENT_MODEL: 'Cost model',
                PAYMENT_MODEL_FREE: 'Free',
                PAYMENT_MODEL_PAID: 'Paid',
                END_OF_PAID_MODEL: 'End date of paid model',
                END_OF_LICENSE: 'License expiry',
                END_OF_LICENSE_INFO: 'License expires in...'
            },
            Common: {
                NO_OPTIONS: 'No options available',
                PLEASE_SELECT: 'Please select',
                PLEASE_SELECT_INPUT: 'Please select or input',
                CREATE: 'Create',
                OPTIONAL: 'Optional',
                LOADING: 'Loading...',
                UNSAVED_CHANGES: 'There are unsaved changes. Do you wish to discard them?',
                NO_ENTRY: noEntry
            },
            Confirmation: {
                TITLE: 'Account activated',
                INFO_ACTIVATION: 'Thank you for activating your account. You are now ready to order!',
                INFO_BEFORE_PASSWORD_RESET: 'Thank you for activating your account. Please choose your password to be able to login.',
                INFO_AFTER_PASSWORD_RESET: 'Thank you for setting your password. You con now log in into your account!',
                GO_TO_LOGIN: 'Go to login',
                ACCOUNT_ALREADY_CONFIRMED: 'The account is already confirmed.'
            },
            Dashboard: {
                WELCOME: 'Welcome!'
            },
            Dialog: {
                ACTIVATE_ACCOUNT: 'Activate account',
                ACTIVATE_ACCOUNT_QUESTION: 'Activate this account? The user will be able to view all training data of the club.',
                REMOVE_USER: 'Remove User',
                REMOVE_USER_QUESTION: 'Are you sure you want to remove this user?',
                DELETE_TEAM: 'Delete Team',
                DELETE_CLUB: 'Delete Club',
                DELETE_TEAM_QUESTION: 'Are you sure you want to delete this team?',
                DELETE_CLUB_QUESTION: 'Are you sure you want to delete this club?',
                REJECT_ACTIVATION: 'Reject account activation',
                REJECT_ACTIVATION_QUESTION: 'Reject the activation of this account? The user will be informed of the decision by mail. Afterwards the account will be deleted.',
                RESEND_DOI: 'Resend confirmation mail,',
                RESEND_DOI_QUESTION: 'The account activation mail will be resent to the address {{email}}. All previous links become invalid.'
            },
            Error: {
                ACCOUNT_ALREADY_EXISTS: 'An account with this E-mail already exists',
                CLUB_ALREADY_EXISTS: 'A club with this serial number already exists',
                CLUB_DOES_NOT_EXIST: 'Invalid serial number',
                MAX_ACCOUNTS_REACHED: 'The maximum number of users for this club has been reached. Please contact the club manager',
                CLUB_NOT_ACTIVE: 'Your club is inactive. If you have any questions, please contact stacy@alpenhunde.de',
                CAPTCHA_INVALID: 'Text is not correct',
                DATA_ALREADY_EXISTS: 'This data already exists',
                ACCOUNT_CONFIRMATION_HINT: 'No activation mail received?',
                ACCOUNT_NOT_ACTIVATED: 'The account is nt activated',
                ACCOUNT_NOT_CONFIRMED: 'Account not confirmed. Activate your account through the link in the activation mail.',
                ACCOUNT_NOT_CONFIRMED_LINK: 'Resend!',
                ACCOUNT_NOT_CONFIRMED_RESEND: 'A new account confirmation link has been send to your email address [{{email}}]',
                FILE_INVALID_TYPE: 'Please use a csv file.',
                FILE_NOT_AN_IMAGE: 'Invalid file type. Please use a valid image type [{{imageTypes}}]',
                FILE_TOO_LARGE: 'Maximum file size exceeded',
                ID_MISMATCH: 'You have provided invalid data.',
                INTERNAL_ERROR: 'An error occurred.',
                INVALID_AUTHENTICATION: 'Either your email or password is incorrect.',
                INVALID_PARAMETER: 'You entered invalid data.',
                GENERAL: 'An error occurred.',
                MISSING_PARAMETER: 'Please fill all the fields.',
                NO_DATA_FOUND: 'The entry cannot be found.',
                NOT_AUTHORIZED: 'You are not authorized for this operation.',
                OPERATION_NOT_SUPPORTED: 'This operation is currently not available.',
                PASSWORD_MISMATCH: 'Passwords don\'t match',
                PROJECT_NAME_DUPLICATED: 'A project with that name already exists.',
                VALIDATION_FAILED: 'You have entered invalid data.',
                UNKNOWN_ERROR: 'An error occurred.',
                WRONG_TOKEN: 'This link is not valid or expired',
                NUMBERS_ONLY: 'Numbers only',
                INT_ONLY_REQ: 'Positive numbers only',
                LOCATION_REQUIRED: 'Location is required if slope is named',
                MISSING_CSV_HEADER_END_TIME: 'Your csv file is missing header "end time".',
                MISSING_CSV_HEADER_IDX: 'Your csv file is missing header "idx".',
                INVALID_FILE_FORMAT: 'Your file is not in an accepted CSV format. Only ";" is accepted as separator.',
                UNPROCESSABLE_CELL_VALUE_TIME: 'A value in the file\'s time columns could not be processed.\n' +
                    'Time values need to have format mm:ss.SS or contain the value DNF.',
                UNPROCESSABLE_VALUE_TIME: 'Time values need to have format mm:ss.SS',
                UNKNOWN_HEADER_FOUND: 'A header in your file could not be recognized.',
                NO_HEADERS_FOUND: 'No headers were found. The first row must be the column names (=headers).',
                NO_DATA_IN_FILE: 'No processable data in your csv file found.',
                DATE_FORMAT_NOT_PARSABLE: 'The date you provided has a format that could not be processed.',
                TEAM_REF_IN_ENTITIES: 'The team you wanted to delete is still referenced in one or more trainings/runs.\n' +
                    'Please remove the referencing runs or trainings and try again.',
                NO_PERMISSION_TO_CREATE_TEAM_IN_CSV: 'A team name in your csv file could not be linked to a existing team from your club \n' +
                    'and you do not have permission to create new teams for your club.'
            },
            FileUpload: {
                DRAG_DROP: 'Drag and drop your file here',
                DRAG_DROP_CUSTOM: 'Drop .csv file here or',
                DRAG_DROP_VERIFICATION: 'Drag and drop your verification file here',
                CHOOSE_FILE: 'choose file ...',
                ACCEPTED_FILE_TYPES: 'Accepted file types',
                MAX_FILE_SIZE: 'Maximum file size',
                IMG_ALT: 'Allergy verification'
            },
            Footer: {
                TERMS_AND_CONDITIONS: 'Terms and conditions',
                IMPRINT: 'Imprint',
                PRIVACY: 'Privacy policy',
                CONTACT: 'Contact'
            },
            General: {
                TERMS_AND_CONDITIONS: 'Terms and Conditions',
                IMPRINT: 'Imprint',
                PRIVACY_POLICY: 'Privacy Policy'
            },
            Login: {
                LOGIN: 'Login',
                EMAIL: 'E-mail',
                PASSWORD: 'Password',
                PASSWORD_RESET: 'Forgot your password?',
                WELCOME: 'Sign in',
                NEW: 'You do not have an account yet?',
                REGISTER_HERE: 'Register here.',
                FIRST_NAME: 'First name (opt.)',
                LAST_NAME: 'Last name',
                SHORT_NAME: 'Short name'
            },
            PasswordReset: {
                REQUEST: 'Reset password',
                INFO_REQUEST: 'To reset you password, please submit your email address. Afterwards you will receive an email to change your password.',
                MAIL_SENT: 'If your e-mail address was correct, a recovery email to change your password has been sent to your e-mail address.',
                REQUEST_PASSWORD: 'Send recovery mail',
                RESET: 'Reset password',
                INFO_RESET: 'Please supply your new password and its repetition to reset your password.',
                RESET_SUCCESS: 'Your password was successfully changed and you can now login again.',
                RESET_BUTTON: 'Reset password'
            },
            Navigation: {
                START: 'Overview',
                ACCOUNT_ADMINISTRATION: 'Accounts',
                PROFILE: 'Profile',
                REGISTER: 'Register',
                LOGIN: 'Login',
                LOGOUT: 'Logout',
                DASHBOARD: 'Dashboard',
                TRAINING: 'Training',
                TEAM: 'Team',
                ACCOUNT_SETTINGS: 'Account settings',
                CLUB_MANAGEMENT: 'Club management',
                CLUB_MANAGEMENT_SINGLE: 'Club management',
                CLUB: 'Club'
            },
            Period: {
                FROM: 'from',
                TO: 'to'
            },
            Role: {
                ADMINISTRATOR: 'Administrator',
                ATHLETE: 'Athlete',
                TRAINER: 'Trainer',
                TEAM: 'Team',
                CLUB_MANAGER: 'Club Manager'
            },
            Registration: {
                TITLE: 'Register',
                SUCCESS: 'Registration successfull! Please click on the link in the confirmation mail to finish the registration.',
                SUCCESS_FOR_TRAINER: 'Your club manager will check your data. You will receive a e-mail after the check.',
                HAVE_ACCOUNT: 'You already have an account?',
                CAPTCHA: 'Please enter the captcha text',
                RELOAD_CAPTCHA: 'Reload'
            },
            Table: {
                SEARCH: 'Search',
                PAGINATION: 'Pagination',
                PREVIOUS: 'Previous',
                NEXT: 'Next',
                NO_RESULT: 'No results have been found.'
            },
            Team: {
                TITLE: 'Teams',
                ADD: 'Add Team',
                UPDATE: 'Update Team',
                NAME: 'Team Name'
            },
            Timespan: {
                LAST_YEAR: 'Last year',
                LAST_MONTH: 'Last month',
                LAST_WEEK: 'Last week',
                NEXT_MONTH: '0-1 Months',
                NEXT_ONE_TO_THREE_MONTHS: '1-3 months',
                NEXT_THREE_TO_SIX_MONTHS: '3-6 months ',
                NEXT_SIX_TO_TWELVE_MONTHS: '6-12 months',
                OVER_ONE_YEAR_IN_FUTURE: 'over 12 months',
                NO_DATE: 'No expiry date'
            },
            Training: {
                RUN: 'Run',
                DATE: 'Date',
                ATHLETE: 'Athlete',
                ATHLETE_SHORT_NAME: 'Short Name',
                ATHLETE_FULL_NAME: 'Full Name',
                FINAL: 'Final',
                FINAL_DIFF: 'Time Difference',
                INTERIM: 'Interim',
                INTERIM_DIFF: 'Interim Difference',
                NOTES: 'Notes',
                SKI: 'Ski',
                BOOTS: 'Boots',
                BINDING: 'Binding',
                SECTION: 'Section time',
                SECTION_FINAL: 'Section time last',
                ADD_TRAINING: 'Add training',
                HEADLINE_OVERVIEW: 'All trainings',
                TRAINING_DETAILS: 'Training details',
                DISCIPLINE: 'Discipline',
                TERRAIN: 'Terrain',
                DISTANCE: 'Distance',
                GATE_DISTANCE: 'Gate distance [m]',
                SLALOM_DISTANCE: 'Gate distance [m]',
                SNOW_TYPE: 'Snow type',
                SLOPE_CONDITION: 'Slope condition',
                NUMBER_OF_GATES: 'Number of gates',
                CHANGES_OF_DIRECTION: 'Changes in direction',
                COURSE_SETUP: 'Course settings',
                COURSE_SETTER: 'Course setter',
                LOCATION: 'Destination',
                PLATE: 'Plate',
                SLOPE: 'Slope name',
                SLOPE_PLACEHOLDER: 'Please select a location first',
                TEAM: 'Team',
                IDX: 'Index',
                CLUB: 'Club',
                FINAL_RANK: 'Rank',
                INTERIM_RANK: 'Rank',
                EDIT_TRAINING_DETAILS: 'Edit training details',
                RUNS: 'Runs',
                RUNTIME: 'Avg. runtime',
                TITLE: 'Training',
                TIME: 'Time',
                DIFFERENCE: 'Difference',
                GEAR: 'Gear',
                DELETE_MODAL_TITLE: 'Delete training',
                DELETE_MODAL_QUESTION: 'Are you sure you want to delete this training?',
                COPY_SHARE_LINK: 'Copy link',
                LINK_COPIED: 'Link copied',
                SHARE_LINK_TITLE: 'Share link',
                SHARED_TRAINING_NOT_FOUND: 'Shared training not found or link expired. Please contact a trainer.',
                SHARE_DESCRIPTION: 'Everyone with a link can view the training in read only mode. The link is valid for 72h.',
                FREE_TRAINING_LIMIT_REACHED: 'The free licence allows you to upload a maximum of 10 trainings. Purchase a paid licence to upload unlimited trainings.',
                FREE_LINK_LIMIT_REACHED: 'Only two active training links are included in the free licence. Purchase a paid licence for your club to share unlimited training data with other users.',
                FREE_LINK_LIMIT_REACHED_ADMIN: 'Maximum number of free training links reached for this club'
            },
            Run: {
                ADD: 'Add run',
                EDIT: 'Edit run',
                DELETE_MODAL_TITLE: 'Delete run',
                DELETE_MODAL_QUESTION: 'Are you sure you want to delete this run?',
                DELETE_MODAL_QUESTION_LAST_RUN: 'This is the last run in this training. If you delete it, the training will also be deleted. Do you want to delete the run anyway?'
            },
            Account: {
                ADD: 'Add user',
                HEADER_LIST: 'User Administration',
                USERNAME: 'E-mail',
                ID: 'Id',
                DISPLAY_NAME: 'Name',
                DELETE_SUCCESS: 'Deleted user \'{{user}}\'',
                DEACTIVATE_SUCCESS: 'The user \'{{user}}\' has been deactivated.',
                DELETE_CONFIRMATION_TITLE: 'Delete User',
                DELETE_CONFIRMATION_DESCRIPTION: 'Are you sure you want to delete the user \'{{user}}\'?',
                LOGIN: 'Login',
                EMAIL: 'E-mail',
                SALUTATION: 'Salutation',
                FIRST_NAME: 'First name (opt.)',
                LAST_NAME: 'Last name',
                PHONE: 'Phone number',
                FAX: 'Fax number',
                PASSWORD_CHANGE: 'Change password',
                PASSWORD_NEW: 'Determine password',
                PASSWORD_REPEAT: 'Repeat password',
                NEW_PASSWORD: 'New password',
                ROLE: 'Role',
                VERIFIED: 'Verified',
                HEADER_NEW: 'Add user',
                HEADER_EDIT: 'Edit user',
                HEADER_PROFILE: 'Edit profile',
                SAVE_SUCCESS: 'Saved user.',
                YOUR_PROFILE: 'Your profile',
                ADDRESS: 'Address',
                CONTACT_PERSON: 'Contact person',
                CLOSING_DAYS: 'Closing days',
                CREDENTIALS: 'Credentials',
                LANGUAGE: 'Language',
                NO_LOGIN_DATA_REQUIRED: 'No login data required',
                TITLE: 'Club Members',
                UPDATE: 'Update Account',
                PASSWORD_NOT_MATCH: 'Passwords do not match.',
                VALID_EMAIL: 'Please provide a valid email address.',
                RESEND_DOI: 'Resend confirmationMail',
                FREE_USER_LIMIT_REACHED: 'The free licence includes only one coach and one manager account. Purchase a paid licence to create more users.',
                FREE_USER_LIMIT_REACHED_ADMIN: 'Maximum number of users in the free version reached.'
            },
            Validation: {
                REQUIRED: 'This field is required.',
                ENDDATE_BEFORE_STARTDATE: 'The end date must be a later date than the start date',
                INVALID_EMAIL: 'Please provide a valid e-mail address.',
                MAX_LENGTH: 'Max. {{count}} characters'
            },
            Weekday: {
                MONDAY: 'Monday',
                TUESDAY: 'Tuesday',
                WEDNESDAY: 'Wednesday',
                THURSDAY: 'Thursday',
                FRIDAY: 'Friday'
            },
            CourseSetting: {
                SLIGHT_TURNING: 'turning',
                TURNING: 'strong turning',
                SLIGHT_TURNING_STRAIGHT: 'slight turning-straight',
                STRAIGHT: 'straight',
                NO_ENTRY: noEntry
            },
            Disciplines: {
                SLALOM: 'Slalom',
                GIANT_SLALOM: 'Giant Slalom',
                SUPER_G: 'Super G',
                DOWNHILL: 'Downhill',
                PARALLEL_GIANT_SLALOM: 'Parallel Giant Slalom',
                NO_ENTRY: noEntry
            },
            SlopeConditions: {
                SOFT: 'soft',
                GRIPPY_SOFT: 'grippy-soft',
                GRIPPY: 'grippy',
                GRIPPY_HARD: 'grippy-hard',
                HARD: 'hard',
                NO_ENTRY: noEntry
            },
            Slope: {
                DELETE_MODAL_TITLE_SLOPE: 'Delete Slope',
                DELETE_MODAL_QUESTION_SLOPE: 'Are you sure you want to delete the slope {{slope}}?',
                DELETE_MODAL_TITLE_LOCATION: 'Delete Location',
                DELETE_MODAL_QUESTION_LOCATION: 'Are you sure you want to delete the location {{location}}?. All corresponding slopes will be deleted as well'
            },
            SnowTypes: {
                NATURAL: 'Natural',
                MIXED: 'Mixed',
                ARTIFICIAL: 'Artificial',
                NO_ENTRY: noEntry
            },
            TerrainTypes: {
                FLAT: 'flat',
                MEDIUM_FLAT: 'medium-flat',
                MEDIUM_STEEP: 'medium-steep',
                STEEP: 'steep',
                NO_ENTRY: noEntry
            },
            SlalomDistances: {
                SLALOM_DISTANCE_4_6M: '4 - 6 meters',
                SLALOM_DISTANCE_LESS_THAN_9M: ' < 9 meters',
                SLALOM_DISTANCE_9_11M: '9 - 11 meters',
                SLALOM_DISTANCE_GREATER_11M: ' > 11 meters',
                GIANT_SLALOM_DISTANCE_LESS_24M: ' < 24 meters',
                GIANT_SLALOM_DISTANCE_24_26M: '24 - 26 meters',
                GIANT_SLALOM_DISTANCE_GREATER_26M: ' > 26 meters',
                NO_ENTRY: 'NO_ENTRY'
            },
            Particle: {
                DATE_ON: 'on'
            },
            Admin: {
                CHANGE_ACCOUNT_ROLES: 'Change account roles',
                ADD_ACCOUNT: 'Add account'
            },
            undefined: noEntry,
            NO_ENTRY: noEntry
        }
    },
    'de-DE': {
        translation: {
            AccountSettings: {
                TITLE: 'Account Einstellungen'
            },
            Address: {
                ADDITION_INFORMATION: 'Adresszusatz',
                CITY: 'Ort',
                HOUSE_NUMBER: 'Hausnummer',
                STREET: 'Straße',
                ZIP: 'Postleitzahl',
                COUNTRY: 'Land'
            },
            Button: {
                BUY: 'Kostenpflichtig kaufen',
                ADD: 'Hinzufügen',
                CANCEL: 'Abbrechen',
                CONFIRM: 'Bestätigen',
                DELETE: 'Löschen',
                EDIT: 'Editieren',
                EXTEND: 'Verlängern',
                FILTER: 'Filtern',
                FILTER_RESET: 'Filter zurücksetzen',
                RESET: 'Zurücksetzen',
                SELECT_ALL: 'Alle auswählen',
                SAVE: 'Speichern',
                SAVE_AND_CONTINUE: 'Speichern und fortfahren',
                SAVE_CHANGES: 'Änderungen speichern',
                CONTINUE: 'Fortfahren',
                OK: 'Ok',
                CLOSE: 'Schließen',
                OPEN: 'Öffnen',
                REMOVE: 'Entfernen',
                REGISTER: 'Registrieren',
                SEND: 'Senden',
                GO_BACK_TO_OVERVIEW: 'Zurück zur Übersicht',
                YES: 'Ja',
                NO: 'Nein',
                IMPORT: 'Importieren',
                IMPORT_TRAINING: 'Training hinzufügen',
                NEXT: 'Weiter',
                OVERVIEW: 'Überblick',
                RUNS: 'Läufe',
                ATHLETE: 'Athleten',
                DOWNLOAD: 'Download',
                RUN_ADD: 'Lauf hinzufügen',
                SHARE: 'Teilen',
                COLUMNS: 'Spalten',
                ADD_ACCOUNT: 'Account hinzufügen',
                ADMIN_MENU: 'Admin Menü',
                VERIFY_ACCOUNT: 'Account freischalten'
            },
            Club: {
                ADD: 'Neuer Verein',
                EDIT: 'Verein bearbeiten',
                NAME: 'Name',
                CLUB_OVERVIEW: 'Alle Vereine',
                SERIAL_NUMBER: 'Seriennummer',
                SERIAL_NUMBER_ALP: 'Seriennummer vom Alpenhunde-System',
                PAYMENT_MODEL: 'Kostenmodell',
                PAYMENT_MODEL_FREE: 'Kostenlos',
                PAYMENT_MODEL_PAID: 'Kostenpflichtig',
                END_OF_PAID_MODEL: 'Enddatum des kostenpflichtigen Models',
                END_OF_LICENSE: 'Ablauf Lizenz',
                END_OF_LICENSE_INFO: 'Lizenz läuft ab in...'
            },
            Common: {
                NO_OPTIONS: 'Keine Optionen verfügbar',
                PLEASE_SELECT: 'Auswählen',
                PLEASE_SELECT_INPUT: 'Auswählen oder Eingeben',
                CREATE: 'Erstelle',
                OPTIONAL: 'Optional',
                LOADING: 'Wird geladen...',
                UNSAVED_CHANGES: 'Es gibt nicht gespeicherte Änderungen. Möchten Sie diese verwerfen?',
                NO_ENTRY: noEntryDe
            },
            Confirmation: {
                TITLE: 'Aktivierung',
                INFO_ACTIVATION: 'Ihr Account wurde aktiviert! Vielen Dank für Ihre Anmeldung. Sie können jetzt Bestellungen tätigen!',
                INFO_BEFORE_PASSWORD_RESET: 'Ihr Account wurde aktiviert! Bitte speichern Sie noch ein Passwort um sich einloggen zu können.',
                INFO_AFTER_PASSWORD_RESET: 'Ihr Passwort wurde gespeichert und Sie können sich jetzt einloggen!',
                GO_TO_LOGIN: 'Zum Login',
                ACCOUNT_ALREADY_CONFIRMED: 'Der Account ist bereits betätigt. Sie können sich einloggen.'
            },
            Dashboard: {
                WELCOME: 'Herzlich Willkommen!'
            },
            Dialog: {
                ACTIVATE_ACCOUNT: 'Account freischalten',
                ACTIVATE_ACCOUNT_QUESTION: 'Diesen Account aktivieren? Der Nutzer wird für alle Trainigsdaten des Vereins freigeschaltet.',
                REMOVE_USER: 'Nutzer entfernen',
                REMOVE_USER_QUESTION: 'Sind sie sicher, dass sie diesen Nutzer entfernen wollen?',
                DELETE_TEAM: 'Team löschen',
                DELETE_CLUB: 'Verein löschen',
                DELETE_TEAM_QUESTION: 'Sind Sie sicher, dass sie dieses Team löschen wollen?',
                DELETE_CLUB_QUESTION: 'Sind Sie sicher, dass sie diesen Verein löschen wollen?',
                REJECT_ACTIVATION: 'Account Freischaltung ablehnen',
                REJECT_ACTIVATION_QUESTION: 'Sind Sie sicher, dass Sie die Freischaltung dieses Accounts ablehnen wollen? ' +
                    'Der Nutzer wird über Ihre Entscheidung per Mail informiert. Danach wird der Account gelöscht.',
                RESEND_DOI: 'Bestätigungs E-Mail erneut senden',
                RESEND_DOI_QUESTION: 'Die Account Aktivierungsmail wird erneut an die E-Mail Adresse {{email}} gesendet. Alle vorherigen Links werden damit ungültig.'

            },
            Error: {
                ACCOUNT_ALREADY_EXISTS: 'Mit dieser E-Mail-Adresse ist bereits ein Konto registriert',
                CLUB_ALREADY_EXISTS: 'Es existiert bereits ein Klub mit dieser Seriennummer',
                CLUB_DOES_NOT_EXIST: 'Seriennummer ungültig',
                MAX_ACCOUNTS_REACHED: 'Die maximale Anzahl an Nutzern für diesen Verein ist erreicht. Bitte wenden Sie sich an den Vereinsmanager',
                CLUB_NOT_ACTIVE: 'Ihr Verein ist inaktiv. Bei Fragen wenden Sie sich bitte an stacy@alpenhunde.de',
                CAPTCHA_INVALID: 'Eingabe ist nicht korrekt',
                DATA_ALREADY_EXISTS: 'Dieser Datensatz existiert bereits',
                ACCOUNT_CONFIRMATION_HINT: 'Keine Aktivierungsemail erhalten?',
                ACCOUNT_NOT_ACTIVATED: 'Der Account ist noch nicht aktiviert. Bitte aktivieren Sie zuerst den Account.',
                ACCOUNT_NOT_CONFIRMED: 'Account nicht bestätigt. Bitte bestätigen Sie Ihren Account über den Link in der Aktivierungsmail.',
                ACCOUNT_NOT_CONFIRMED_LINK: 'Erneut senden!',
                ACCOUNT_NOT_CONFIRMED_RESEND: 'Eine neue Aktivierungsmail wurde an ihre Emailaddresse [{{email}}] versandt.',
                FILE_INVALID_TYPE: 'Bitte verwende eine .csv Datei.',
                FILE_NOT_AN_IMAGE: 'Ungültiger Dateityp. Bitte verwende einen der folgenden [{{imageTypes}}]',
                FILE_TOO_LARGE: 'Maximale Dateigröße überschritten',
                GENERAL: 'Es ist ein Fehler aufgetreten.',
                ID_MISMATCH: 'Sie haben eine ungültige Verknüpfung angegeben.',
                INTERNAL_ERROR: 'Es ist ein Fehler aufgetreten.',
                INVALID_AUTHENTICATION: 'Entweder die Emailadresse oder das Passwort ist inkorrekt.',
                INVALID_PARAMETER: 'Sie haben ungültige Werte angegeben.',
                MISSING_PARAMETER: 'Bitte fülle alle Angaben vollständig aus.',
                NO_DATA_FOUND: 'Der Eintrag wurde nicht gefunden.',
                NOT_AUTHORIZED: 'Sie haben leider keine Berechtigung für diese Aktion.',
                OPERATION_NOT_SUPPORTED: 'Diese Aktion ist derzeit leider nicht möglich.',
                PASSWORD_MISMATCH: 'Passwörter stimmen nicht überein',
                PROJECT_NAME_DUPLICATED: 'Ein Projekt mit diesem Namen existiert bereits.',
                UNKNOWN_ERROR: 'Es ist ein Fehler aufgetreten.',
                WRONG_TOKEN: 'Der angegebene Link ist falsch oder abgelaufen',
                VALIDATION_FAILED: 'Es wurden ungültige Daten eingegeben.',
                NUMBERS_ONLY: 'Nur Zahlen sind erlaubt.',
                INT_ONLY_REQ: 'Pflichtfeld. Nur positive Ganzzahlen sind erlaubt.',
                LOCATION_REQUIRED: 'Ort ist pflichtfeld wenn Piste definiert ist.',
                MISSING_CSV_HEADER_END_TIME: 'Ihre .csv Datei hat keinen Spaltenname/Header "end time".',
                MISSING_CSV_HEADER_IDX: 'Ihre .csv Datei hat keinen Spaltenname/Header "idx".',
                MISSING_CSV_HEADER_NAME: 'Ihre .csv Datei hat keinen Spaltenname/Header "name".',
                INVALID_FILE_FORMAT: 'Ihre Datei ist nicht in einem akzeptierten .csv Format.',
                UNPROCESSABLE_CELL_VALUE_TIME: 'Ein Wert in einer Ihrer Zeitspalten konnte nicht verarbeitet werden.\n ' +
                    'Zeitwerte müssen das Format mm:ss,SS haben oder den Wert DNF enthalten',
                UNPROCESSABLE_VALUE_TIME: 'Zeitwerte müssen das Format mm:ss,SS haben',
                UNKNOWN_HEADER_FOUND: 'Ein Spaltenname/Header in Ihrer Datei wurde nicht erkannt.',
                NO_HEADERS_FOUND: 'Keine Spaltenname/Header erkannt. Die erste Zeile muss die jeweiligen Spaltennamen/Header enthalten.',
                NO_DATA_IN_FILE: 'Keine zu verarbeitenden Daten in der Datei gefunden.',
                DATE_FORMAT_NOT_PARSABLE: 'Das Datum, das Sie angegeben haben, hat ein Format, das nicht verarbeitet werden konnte.',
                TEAM_REF_IN_ENTITIES: 'Das zu löschende Team wird noch in einem oder mehreren Läufen/Trainings referenziert.\n' +
                    'Bitte ändern/entfernen Sie die Referenz oder die Läufe/Trainings.',
                NO_PERMISSION_TO_CREATE_TEAM_IN_CSV: 'Ein Teamname in Ihrer .csv Datei konnte keinem Team in der Datenbank zugeordnet werden \n ' +
                    'und sie besitzen nicht die Rechte neue Teams für Ihren Verein zu erstellen.'
            },

            FileUpload: {
                DRAG_DROP: 'Ziehen Sie Ihre Dateien in dieses Feld',
                DRAG_DROP_CUSTOM: '.csv Datei hier ablegen oder',
                CHOOSE_FILE: 'Datei wählen ...',
                ACCEPTED_FILE_TYPES: 'Erlaubte Dateiendungen',
                MAX_FILE_SIZE: 'Maximale Dateigröße'
            },
            Footer: {
                TERMS_AND_CONDITIONS: 'AGB',
                IMPRINT: 'Impressum',
                PRIVACY: 'Datenschutz',
                CONTACT: 'Kontakt'
            },
            General: {
                TERMS_AND_CONDITIONS: 'Allgemeine Geschäftsbedingungen',
                IMPRINT: 'Impressum',
                PRIVACY_POLICY: 'Datenschutz'
            },

            Login: {
                LOGIN: 'Einloggen',
                EMAIL: 'E-Mail',
                PASSWORD: 'Passwort',
                PASSWORD_RESET: 'Passwort vergessen?',
                WELCOME: 'Anmelden',
                NEW: 'Neu hier?',
                REGISTER_HERE: 'Hier geht\'s zur Registrierung.',
                FIRST_NAME: 'Vorname (opt.)',
                LAST_NAME: 'Nachname',
                SHORT_NAME: 'Kürzel'
            },
            PasswordReset: {
                REQUEST: 'PW zurücksetzen',
                INFO_REQUEST: 'Um Ihr Passwort zurücksetzen zu können, geben Sie bitte die E-Mailadresse Ihres Accounts an. ' +
                    'Danach erhalten Sie eine Mail zum Zurücksetzen Ihres Passwortes.',
                MAIL_SENT: 'Falls Ihre E-Mail-Adresse korrekt ist, finden Sie in Kürze eine E-Mail mit einem Passwort-Link in Ihrem Postfach',
                REQUEST_PASSWORD: 'Wiederherstellungsmail versenden',
                RESET: 'Passwort zurücksetzen',
                INFO_RESET: 'Geben Sie bitte Ihr Passwort und dessen Wiederholung ein, um Ihr Passwort zu ändern.',
                RESET_SUCCESS: 'Ihr Passwort wurde erfolgreich geändert und Sie können sich damit nun wieder einloggen.',
                RESET_BUTTON: 'Passwort zurücksetzen'
            },

            Navigation: {
                START: 'Übersicht',
                ACCOUNT_ADMINISTRATION: 'Benutzer',
                PROFILE: 'Profil',
                REGISTER: 'Registrieren',
                LOGIN: 'Login',
                LOGOUT: 'Ausloggen',
                DASHBOARD: 'Dashboard',
                TRAINING: 'Training',
                TEAM: 'Team',
                ACCOUNT_SETTINGS: 'Account Einstellungen',
                CLUB_MANAGEMENT: 'Vereine verwalten',
                CLUB_MANAGEMENT_SINGLE: 'Verein verwalten'
            },
            Period: {
                FROM: 'von',
                TO: 'bis'
            },
            Role: {
                ADMINISTRATOR: 'Administrator',
                ATHLETE: 'Athlet',
                TRAINER: 'Trainer',
                TEAM: 'Team',
                CLUB_MANAGER: 'Vereinsmanager'
            },
            Registration: {
                TITLE: 'Registrieren',
                SUCCESS: 'Registrierung erfolgreich! Klicken Sie auf den Link in der Bestätigungsmail um ein Passwort zu vergeben',
                SUCCESS_FOR_TRAINER: 'Ihre Daten werden von Ihrem Vereinsmanager geprüft. Nach erfolgter Prüfung erhalten Sie eine Mail mit weiteren Informationen.',
                HAVE_ACCOUNT: 'Sie haben schon einen Account?',
                CAPTCHA: 'Bitte geben Sie den captcha Text ein',
                RELOAD_CAPTCHA: 'Neu laden'
            },
            Table: {
                SEARCH: 'Suche',
                PAGINATION: 'Seiten',
                PREVIOUS: 'Vorige',
                NEXT: 'Nächste',
                NO_RESULT: 'Es wurden keine Einträge gefunden.'
            },
            Account: {
                ADD: 'Nutzer hinzufügen',
                HEADER_LIST: 'Benutzer',
                USERNAME: 'E-Mail',
                ID: 'Id',
                DISPLAY_NAME: 'Name',
                EMAIL: 'E-Mail',
                SALUTATION: 'Anrede',
                FIRST_NAME: 'Vorname (opt.)',
                LAST_NAME: 'Nachname',
                PHONE: 'Telefonnummer',
                LOGIN: 'Login',
                PASSWORD_CHANGE: 'Neues Passwort',
                PASSWORD_NEW: 'Passwort festlegen',
                PASSWORD_REPEAT: 'Passwort wiederholen',
                NEW_PASSWORD: 'Neues Passwort',
                ROLE: 'Rolle',
                VERIFIED: 'Verifiziert',
                HEADER_NEW: 'Benutzer hinzufügen',
                HEADER_EDIT: 'Benutzer bearbeiten',
                HEADER_PROFILE: 'Profil bearbeiten',
                SAVE_SUCCESS: 'Der Benutzer wurde gespeichert.',
                DELETE_SUCCESS: 'Der Anwender \'{{user}}\' wurde gelöscht.',
                DEACTIVATE_SUCCESS: 'Der Anwender \'{{user}}\' wurde deaktiviert.',
                DELETE_CONFIRMATION_TITLE: 'Anwender löschen',
                DELETE_CONFIRMATION_DESCRIPTION: 'Möchten Sie den Anwender \'{{user}}\' wirklich löschen?',
                YOUR_PROFILE: 'Ihr Profil',
                CONTACT_PERSON: 'Ansprechpartner',
                CREDENTIALS: 'Zugangsdaten',
                TITLE: 'Vereinsmitglieder',
                UPDATE: 'Account ändern',
                PASSWORD_NOT_MATCH: 'Passwörter stimmen nicht überein.',
                VALID_EMAIL: 'Bitte geben Sie eine gültige Email-Adresse an.',
                RESEND_DOI: 'Bestätigungs-Mail nochmal senden',
                FREE_USER_LIMIT_REACHED: 'In der kostenlosen Lizenz sind nur ein Trainer- und ein Manageraccount enthalten. ' +
                    'Erwerben Sie ein kostenpflichtige Lizenz um mehr Nutzer anzulegen.',
                FREE_USER_LIMIT_REACHED_ADMIN: 'Maximale Nutzeranzahl in der kostenlosen Version erreicht'
            },
            Team: {
                TITLE: 'Teams',
                ADD: 'Team hinzufügen',
                UPDATE: 'Team ändern',
                NAME: 'Team Name'
            },
            Timespan: {
                LAST_YEAR: 'Letztes Jahr',
                LAST_MONTH: 'Letzter Monat',
                LAST_WEEK: 'Letzte Woche',
                NEXT_MONTH: '0-1 Monate',
                NEXT_ONE_TO_THREE_MONTHS: '1-3 Monaten',
                NEXT_THREE_TO_SIX_MONTHS: '3-6 Monaten',
                NEXT_SIX_TO_TWELVE_MONTHS: '6-12 Monaten',
                OVER_ONE_YEAR_IN_FUTURE: 'über 12 Monaten',
                NO_DATE: 'Kein Ablaufdatum'
            },
            Training: {
                RUN: 'Lauf',
                DATE: 'Datum',
                ATHLETE: 'Athlet',
                ATHLETE_SHORT_NAME: 'Kürzel',
                ATHLETE_FULL_NAME: 'Name',
                FINAL: 'Endzeit',
                FINAL_DIFF: 'Differenz Endzeit',
                INTERIM: 'Zwischenzeit',
                INTERIM_DIFF: 'Differenz Zwischenzeit',
                NOTES: 'Notizen',
                SKI: 'Ski',
                BOOTS: 'Skischuh',
                BINDING: 'Bindung',
                SECTION: 'Teilzeit',
                SECTION_FINAL: 'Teilzeit Ende',
                ADD_TRAINING: 'Training hinzufügen',
                HEADLINE_OVERVIEW: 'Alle Trainings',
                TRAINING_DETAILS: 'Trainingsangaben',
                DISCIPLINE: 'Disziplin',
                TERRAIN: 'Gelände',
                DISTANCE: 'Abstand',
                GATE_DISTANCE: 'Torabstand [m]',
                SLALOM_DISTANCE: 'Torabstand [m]',
                SNOW_TYPE: 'Schneeart',
                SLOPE_CONDITION: 'Pistenzustand',
                NUMBER_OF_GATES: 'Anzahl Tore',
                CHANGES_OF_DIRECTION: 'Richtungswechsel',
                COURSE_SETUP: 'Charakteristik',
                COURSE_SETTER: 'Kurssetzer',
                LOCATION: 'Ort',
                PLATE: 'Platte',
                SLOPE: 'Piste',
                SLOPE_PLACEHOLDER: 'Bitte zuerst einen Ort auswählen',
                TEAM: 'Team',
                IDX: 'Index',
                CLUB: 'Verein',
                FINAL_RANK: 'Rang',
                INTERIM_RANK: 'Rang',
                EDIT_TRAINING_DETAILS: 'Trainingsdetails anpassen',
                RUNS: 'Läufe',
                RUNTIME: 'Durchschnittl. Laufzeit',
                TITLE: 'Training',
                TIME: 'Zeit',
                DIFFERENCE: 'Differenz',
                GEAR: 'Ausrüstung',
                DELETE_MODAL_TITLE: 'Training löschen',
                DELETE_MODAL_QUESTION: 'Möchtest du dieses Training wirklich löschen?',
                COPY_SHARE_LINK: 'Link kopieren',
                LINK_COPIED: 'Link kopiert',
                SHARE_LINK_TITLE: 'Linkfreigabe',
                SHARED_TRAINING_NOT_FOUND: 'Training nicht gefunden oder Link abgelaufen. Bitte kontaktieren Sie einen Trainer.',
                SHARE_DESCRIPTION: 'Jeder mit Link kann das Training ansehen, aber nicht bearbeiten. Der Link ist 72h gültig.',
                FREE_TRAINING_LIMIT_REACHED: 'In der kostenlosen Lizenz ist der Upload von maximal 10 Trainings möglich. Erwerben Sie eine kostenpflichtige Lizenz, um unbegrenzt Trainings hochzuladen.',
                FREE_LINK_LIMIT_REACHED: 'In der kostenlosen Lizenz sind nur zwei aktive Trainingslinks enthalten. Erwerben Sie eine kostenpflichtige Lizenz für Ihren Verein, um unbegrenzt Trainingsdaten mit anderen Nutzern zu teilen.',
                FREE_LINK_LIMIT_REACHED_ADMIN: 'Maximale Anzahl an kostenlosen Trainingslinks für diesen Verein erreicht'
            },
            Run: {
                ADD: 'Lauf hinzufügen',
                EDIT: 'Lauf bearbeiten',
                DELETE_MODAL_TITLE: 'Lauf löschen',
                DELETE_MODAL_QUESTION: 'Möchtest du diesen Lauf wirklich löschen?',
                DELETE_MODAL_QUESTION_LAST_RUN: 'Dies ist der letzte Lauf in diesem Training. Wenn du ihn löschst, wird auch das Training gelöscht.Möchtest du den Lauf trotzdem löschen?'
            },
            Validation: {
                REQUIRED: 'Pflichtfeld.',
                ENDDATE_BEFORE_STARTDATE: 'Das Endatum muss hinter dem Startdatum liegen.',
                INVALID_EMAIL: 'Bitte geben Sie eine gültige Emailadresse an.',
                MAX_LENGTH: 'Max. {{count}} Zeichen'
            },
            Weekday: {
                MONDAY: 'Montag',
                TUESDAY: 'Dienstag',
                WEDNESDAY: 'Mittwoch',
                THURSDAY: 'Donnerstag',
                FRIDAY: 'Freitag'
            },
            CourseSetting: {
                SLIGHT_TURNING: 'drehend',
                TURNING: 'stark drehend',
                SLIGHT_TURNING_STRAIGHT: 'schwach drehend zu flüssig',
                STRAIGHT: 'flüssig',
                NO_ENTRY: noEntryDe
            },
            Disciplines: {
                SLALOM: 'Slalom',
                GIANT_SLALOM: 'Riesenslalom',
                SUPER_G: 'Super G',
                DOWNHILL: 'Abfahrt',
                PARALLEL_GIANT_SLALOM: 'Parallel Riesenslalom',
                NO_ENTRY: noEntryDe
            },
            Slope: {
                DELETE_MODAL_TITLE_SLOPE: 'Piste Löschen',
                DELETE_MODAL_QUESTION_SLOPE: 'Möchtest du die Piste {{slope}} wirklich löschen?',
                DELETE_MODAL_TITLE_LOCATION: 'Ort Löschen',
                DELETE_MODAL_QUESTION_LOCATION: 'Möchtest du den Ort {{location}} wirklich löschen? Alle zugehörigen Pisten werden ebenfalls gelöscht'
            },
            SlopeConditions: {
                SOFT: 'weich',
                GRIPPY_SOFT: 'griffig-weich',
                GRIPPY: 'griffig',
                GRIPPY_HARD: 'griffig-hart',
                HARD: 'hart',
                NO_ENTRY: noEntryDe
            },
            SnowTypes: {
                NATURAL: 'natürlich',
                MIXED: 'gemischt',
                ARTIFICIAL: 'Kunstschnee',
                NO_ENTRY: noEntryDe
            },
            TerrainTypes: {
                FLAT: 'flach',
                MEDIUM_FLAT: 'mittel-flach',
                MEDIUM_STEEP: 'mittel-steil',
                STEEP: 'steil',
                NO_ENTRY: noEntryDe
            },
            SlalomDistances: {
                SLALOM_DISTANCE_4_6M: '4 - 6 Meter',
                SLALOM_DISTANCE_LESS_THAN_9M: ' < 9 Meter',
                SLALOM_DISTANCE_9_11M: '9 - 11 Meter',
                SLALOM_DISTANCE_GREATER_11M: ' > 11 Meter',
                GIANT_SLALOM_DISTANCE_LESS_24M: ' < 24 Meter',
                GIANT_SLALOM_DISTANCE_24_26M: '24 - 26 Meter',
                GIANT_SLALOM_DISTANCE_GREATER_26M: ' > 26 Meter',
                NO_ENTRY: 'NO_ENTRY'
            },
            Particle: {
                DATE_ON: 'am'
            },
            Admin: {
                CHANGE_ACCOUNT_ROLES: 'Account Rollen verändern',
                ADD_ACCOUNT: 'Account hinzufügen'
            },
            undefined: noEntryDe,
            NO_ENTRY: noEntryDe
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        fallbackLng: 'de-DE',
        lng: 'de-DE',
        debug: false,
        resources
    }).then();
export default i18n;
